module.exports = __webpack_public_path__ + "static/media/accSelected.c704058f.svg";